import { matchPath } from 'react-router-dom';
import navConfig from '../../layouts/dashboard/navbar/NavConfig';

export * from './type';

// ----------------------------------------------------------------------

export { default as NavSectionVertical } from './vertical';
export { default as NavSectionHorizontal } from './horizontal';

export function isExternalLink(path: string) {
  return path.includes('http');
}

export function getActive(path: string, pathname: string) {
  return path ? !!matchPath({ path: path, end: false }, pathname) : false;
}

const getAllNavPaths = (config: any[]): string[] => {
  const paths: string[] = [];
  const addItems = (items: any[]) => {
    items.forEach((item) => {
      if (item.path) paths.push(item.path);
      if (item.children) addItems(item.children);
    });
  };
  config.forEach((group) => {
    if (group.items) addItems(group.items);
  });
  return paths;
};

const ALL_NAV_PATHS = getAllNavPaths(navConfig);

export function isNavActive(path: string, pathname: string): boolean {
  if (!path) return false;
  if (pathname === path) return true;

  if (pathname.startsWith(path + '/')) {
    // Check if any other path in navConfig is an exact match for pathname
    // or is a longer prefix match than `path`
    const hasBetter = ALL_NAV_PATHS.some((p) => {
      if (p === path) return false;
      if (p === pathname) return true;
      if (pathname.startsWith(p + '/') && p.length > path.length) return true;
      return false;
    });

    return !hasBetter;
  }

  return false;
}
